import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/socialProofPDP/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { SOCIAL_PROOF_PDP } from 'constants/TestTarget';

const showSocialProofPDPSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    control: testReady && experience === SOCIAL_PROOF_PDP.CONTROL,
    challengerOne: testReady && experience === SOCIAL_PROOF_PDP.CHALLENGER_ONE,
    challengerTwo: testReady && experience === SOCIAL_PROOF_PDP.CHALLENGER_TWO
}));

export { showSocialProofPDPSelector };
